export default {"src":"/_next/static/media/CloseButton.3eba706a.svg","height":40,"width":40};